module.exports = __webpack_public_path__ + "img/features4.5df19be5.png";